import React, { useEffect, useState } from "react";
import "./RecruiterSideBar.scss";
import { Divider, Menu } from "antd";
import logo from "@assets/img/logo/logo-only-white.svg";
import { useLocation, useNavigate } from "react-router-dom";
import { LeftOutlined, SearchOutlined } from "@ant-design/icons";

interface TRecruiterSideBar {
  sidebarCollapse: boolean;
  setSidebarCollapse: (type: boolean) => void;
}

const RecruiterSideBar: React.FC<TRecruiterSideBar> = ({
  sidebarCollapse,
  setSidebarCollapse,
}) => {
  const recruiterPath = {
    dashboard: "",
    campaign: "campaign",
    job: "job",
    setting: "setting",
    profile: "profile",
  };
  const [selectedKeys, setSelectedKeys] = useState(recruiterPath.dashboard);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    Object.values(recruiterPath).forEach((item) => {
      if (location.pathname.substring(17) == item) {
        setSelectedKeys(item);
      } else if (location.pathname.substring(17) == "sourcing") {
        setSelectedKeys(recruiterPath.campaign);
      }
    });
  }, [location.pathname]);

  const items = [
    {
      key: recruiterPath.dashboard,
      icon: <i className="fa-solid fa-chart-line nav-item-icon"></i>,
      label: "Dashboard",
    },
    {
      key: recruiterPath.campaign,
      icon: <i className="fa-solid fa-bars-staggered nav-item-icon"></i>,
      label: "Campaign",
    },
    {
      key: recruiterPath.job,
      icon: <i className="fa-solid fa-briefcase nav-item-icon"></i>,
      label: "Job Hub",
    },
    {
      key: recruiterPath.setting,
      icon: <i className="fa-solid fa-gear nav-item-icon"></i>,
      label: "Settings",
    },
    {
      key: "separator",
      label: (
        <Divider style={{ backgroundColor: "rgba(255, 255, 255, 0.3)" }} />
      ),
      title: "",
      disabled: true,
    },
    {
      key: recruiterPath.profile,
      icon: <i className="fa-solid fa-user nav-item-icon"></i>,
      label: "Profile",
    },
  ];

  return (
    <div className={`RecruiterSideBar ${sidebarCollapse ? "collapsed" : ""}`}>
      <div className="RecruiterSideBar-container d-flex flex-column p-3 h-100">
        <a href="/" className="sidebar-logo mb-3">
          <img src={logo} width={50} />
          <span className="sidebar-title">HEPPAI</span>
        </a>
        <button
          className="collapse-btn"
          onClick={() => setSidebarCollapse(!sidebarCollapse)}
        >
          <LeftOutlined color="#132050" rotate={sidebarCollapse ? 180 : 0} />
        </button>
        <div className="input-container">
          <SearchOutlined className="prefix" style={{ color: "#fff" }} />
          <input
            type="text"
            className="form-control-search"
            placeholder="Search"
          />
        </div>
        <div className="recruiter-menu mt-3 mb-auto">
          <Menu
            defaultSelectedKeys={[selectedKeys]}
            mode="inline"
            selectedKeys={[selectedKeys]}
            items={items}
            onClick={(item: any) => {
              setSelectedKeys(item.key);
              navigate(item.key);
            }}
            inlineCollapsed={sidebarCollapse}
          />
        </div>
      </div>
    </div>
  );
};

export default RecruiterSideBar;
